/* Claude 4.63 — theme-native preorder.

   Rules live in snippets/claude-preorder.liquid; this file only APPLIES them.

   PRODUCT FORMS. buy-buttons.liquid emits, per form, a
   <script type="application/json" data-claude-preorder="<form id">> with the
   state of every variant. Dawn does NOT re-render the buy buttons on variant
   change (product-info.js only toggles the button with "Add to basket" /
   "Sold out"), so after every variant change this file re-applies: button
   label, disabled state, wallet hidden/shown, message, the "Pre-order" line
   item property (disabled inputs are not submitted), and the quantity cap.

   LIMIT. The theme can't make Shopify checkout refuse a CONTINUE variant, so
   the cap is enforced here, three ways:
     1. product form submit — checks what is already in the basket first;
     2. basket drawer (sections/claude-cart-drawer.liquid) — its +/− buttons
        carry data-ccd-qty="<new qty>"; clicks above the cap are stopped;
     3. /cart page — quantity inputs get max/data-max.
   The cap travels with the line as the hidden property _po_max (underscore
   properties are hidden in checkout and on the /cart page).

   FAIL OPEN: if anything here throws or /cart.js can't be read, the add goes
   ahead exactly as Dawn would do it. Worst case is Rez-era behaviour, never a
   dead button. */
(function () {
  'use strict';
  if (window.__claudePreorderInit) return;
  window.__claudePreorderInit = true;

  var C = window.claudePreorder || {};
  var PROP = C.property || 'Pre-order';

  function strings() {
    var v = window.variantStrings || {};
    return { add: v.addToCart || 'Add to basket', sold: v.soldOut || 'Sold out' };
  }

  function dataFor(s) {
    if (!s.__d) {
      try { s.__d = JSON.parse(s.textContent); } catch (e) { s.__d = { v: {} }; }
    }
    return s.__d;
  }

  function scriptForForm(form) {
    if (!form || !form.id) return null;
    return document.querySelector('script[data-claude-preorder="' + form.id + '"]');
  }

  function stateFor(form, s) {
    var idInput = form.querySelector('input[name="id"]');
    var vid = idInput && idInput.value;
    var st = (vid && dataFor(s).v[vid]) || { m: 'normal', x: null };
    return { vid: vid, st: st };
  }

  function qtyInput(form) {
    return document.querySelector('input[name="quantity"][form="' + form.id + '"]') ||
      form.querySelector('input[name="quantity"]');
  }

  function apply(s) {
    var form = document.getElementById(s.getAttribute('data-claude-preorder'));
    if (!form) return;
    var cur = stateFor(form, s);
    var st = cur.st;
    var pre = st.m === 'preorder';
    var S = strings();

    var btn = form.querySelector('button[name="add"]');
    var span = btn && btn.querySelector('span');
    var row = form.querySelector('.product-form__buttons');

    if (row) row.classList.toggle('claude-preorder-row', pre && !!C.hideWallet);

    if (btn && span) {
      if (pre) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        if (span.textContent !== C.button) span.textContent = C.button;
        btn.setAttribute('data-claude-po', '1');
      } else if (st.m === 'full') {
        btn.disabled = true;
        if (span.textContent !== S.sold) span.textContent = S.sold;
        btn.setAttribute('data-claude-po', '1');
      } else if (btn.hasAttribute('data-claude-po')) {
        btn.removeAttribute('data-claude-po');
        if (!btn.disabled && span.textContent !== S.add) span.textContent = S.add;
      }
    }

    var prop = form.querySelector('[data-claude-preorder-prop]');
    if (prop) {
      prop.disabled = !pre;
      prop.value = pre ? (st.p || '') : '';
    }
    var pmax = form.querySelector('[data-claude-preorder-max]');
    if (pmax) {
      var capped = (pre || st.m === 'stock') && st.x != null;
      pmax.disabled = !capped;
      pmax.value = capped ? String(st.x) : '';
    }

    var msg = form.querySelector('[data-claude-preorder-msg]');
    if (msg) {
      msg.hidden = !pre;
      var mt = msg.querySelector('[data-claude-preorder-msg-text]') || msg;
      if (pre && mt.textContent !== st.t) mt.textContent = st.t || '';
    }
    var left = form.querySelector('[data-claude-preorder-left]');
    if (left) {
      var showLeft = pre && C.showLeft && st.x != null;
      left.hidden = !showLeft;
      if (showLeft) left.textContent = (C.leftText || '').replace('{n}', st.x);
    }

    /* 4.64: no "Pairs well with" upsell on preorder (Liquid skips it on load;
       this covers switching variant). Unticked so it can never add silently. */
    form.querySelectorAll('.claude-pairs').forEach(function (pc) {
      if (pre) {
        pc.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
        pc.hidden = true;
        pc.setAttribute('data-claude-po-hidden', '1');
      } else if (pc.hasAttribute('data-claude-po-hidden')) {
        pc.hidden = false;
        pc.removeAttribute('data-claude-po-hidden');
      }
    });

    /* Dawn's stock line ("Out of stock") contradicts a Preorder button. */
    var info = form.closest('product-info') || form.closest('.product__info-container');
    if (info) {
      info.querySelectorAll('[id^="Inventory-"]').forEach(function (inv) {
        inv.classList.toggle('claude-po-hide', pre);
      });

      /* 4.64: "PRE-ORDER" tag beside the price. Inserted as a SIBLING of the
         #price-… block, because Dawn replaces that block's innerHTML on every
         variant change and would wipe anything placed inside it. */
      var price = info.querySelector('[id^="price-"]');
      /* claude-rating-row moves the price into its own row after load, so a tag
         inserted earlier can be left behind: keep only the one right after the
         price. */
      info.querySelectorAll('.claude-preorder-pricetag').forEach(function (t) {
        if (!price || t.previousElementSibling !== price) t.parentNode.removeChild(t);
      });
      if (price && C.priceTag) {
        var tag = price.parentNode.querySelector(':scope > .claude-preorder-pricetag');
        if (pre && !tag) {
          tag = document.createElement('span');
          tag.className = 'claude-preorder-pricetag';
          tag.textContent = C.priceTagText || 'Pre-order';
          price.parentNode.insertBefore(tag, price.nextSibling);
        } else if (!pre && tag) {
          tag.parentNode.removeChild(tag);
        }
      }
    }

    var q = qtyInput(form);
    if (q) {
      if ((pre || st.m === 'stock') && st.x != null) {
        q.max = st.x;
        q.setAttribute('data-max', st.x);
        q.setAttribute('data-claude-po-max', '1');
        if (parseInt(q.value, 10) > st.x) q.value = st.x;
      } else if (q.hasAttribute('data-claude-po-max')) {
        q.removeAttribute('data-claude-po-max');
        q.removeAttribute('max');
        q.removeAttribute('data-max');
      }
    }
  }

  function applyAll() {
    document.querySelectorAll('script[data-claude-preorder]').forEach(function (s) {
      try { apply(s); } catch (e) { /* fail open */ }
    });
  }

  /* Variant change. Dawn sets input[name=id] and dispatches 'change' BEFORE it
     toggles the button text, so apply on the next tick as well, and again on
     the variantChange pub/sub event (fired after the toggle). */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') {
      applyAll();
      setTimeout(applyAll, 0);
    }
  });

  function hookPubSub() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(applyAll, 0); });
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(syncCart, 50); });
    }
  }

  /* ---------- basket helpers ---------- */
  function cartUrl() {
    return ((window.routes && window.routes.cart_url) || '/cart') + '.js';
  }
  function getCart() {
    return fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function showFormError(form, text) {
    var pf = form.closest('product-form');
    if (pf && typeof pf.handleErrorMessage === 'function') {
      pf.handleErrorMessage(text);
      return;
    }
    alert(text);
  }

  /* ---------- 1. product form submit guard ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var s = scriptForForm(form);
    if (!s) return;
    if (form.__claudePoOk) { form.__claudePoOk = false; return; }
    var cur;
    try { cur = stateFor(form, s); } catch (err) { return; }
    var st = cur.st;
    if (!((st.m === 'preorder' || st.m === 'stock') && st.x != null)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var q = qtyInput(form);
    var want = q ? (parseInt(q.value, 10) || 1) : 1;
    var submitter = e.submitter || form.querySelector('button[name="add"]');

    function go() {
      form.__claudePoOk = true;
      if (form.requestSubmit) form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    getCart().then(function (cart) {
      var inCart = 0;
      (cart.items || []).forEach(function (it) {
        if (String(it.variant_id) === String(cur.vid)) inCart += it.quantity;
      });
      var room = st.x - inCart;
      if (want > room) {
        var text;
        if (st.m === 'stock') text = (C.stockText || '').replace('{n}', st.x);
        else text = room > 0 ? (C.limitText || '').replace('{n}', room) : C.limitReached;
        showFormError(form, text);
        return;
      }
      go();
    }).catch(go);
  }, true);

  /* ---------- 2 + 3. basket drawer and /cart page ---------- */
  var cartState = null;

  function lineCap(item) {
    var p = item && item.properties;
    if (!p || p._po_max == null || p._po_max === '') return null;
    var n = parseInt(p._po_max, 10);
    return isNaN(n) ? null : n;
  }

  function isPreLine(item) {
    var p = item && item.properties;
    return !!(p && p[PROP]);
  }

  function decorate() {
    if (!cartState) return;
    var items = cartState.items || [];
    var hasPre = false;
    var hasOther = false;

    items.forEach(function (item, i) {
      var line = i + 1;
      var pre = isPreLine(item);
      if (pre) hasPre = true; else hasOther = true;

      /* Drawer: show the preorder timing under the title (the drawer does not
         render line item properties itself). */
      var li = document.querySelector('.ccd-item[data-line="' + line + '"]');
      if (li) {
        var text = li.querySelector('.ccd-item-text');
        var tag = li.querySelector('.claude-preorder-line');
        if (pre && text) {
          if (!tag) {
            tag = document.createElement('span');
            tag.className = 'claude-preorder-line';
            text.appendChild(tag);
          }
          var label = PROP + ': ' + item.properties[PROP];
          if (tag.textContent !== label) tag.textContent = label;
        } else if (tag) {
          tag.parentNode.removeChild(tag);
        }
        var cap = lineCap(item);
        li.querySelectorAll('[data-ccd-qty]').forEach(function (b) {
          if (b.classList.contains('ccd-item-remove')) return;
          var to = parseInt(b.getAttribute('data-ccd-qty'), 10);
          var over = cap != null && to > cap;
          b.classList.toggle('claude-po-capped', over);
          if (over) b.setAttribute('aria-disabled', 'true'); else if (b.getAttribute('aria-disabled') === 'true' && b.classList.contains('ccd-qty-btn')) b.removeAttribute('aria-disabled');
        });
      }

      /* /cart page: native number inputs. */
      var cap2 = lineCap(item);
      if (cap2 != null) {
        document.querySelectorAll('#Quantity-' + line + ', cart-items input.quantity__input[data-index="' + line + '"]').forEach(function (inp) {
          inp.max = cap2;
          inp.setAttribute('data-max', cap2);
        });
      }
    });

    /* Mixed basket note */
    var show = !!C.cartNote && hasPre && hasOther;
    [document.querySelector('.ccd-footer'), document.querySelector('#main-cart-footer .cart__footer, .cart__footer')].forEach(function (host) {
      if (!host) return;
      var note = host.querySelector(':scope > .claude-preorder-cartnote');
      if (show) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'claude-preorder-cartnote';
          host.insertBefore(note, host.firstChild);
        }
        note.textContent = C.cartNote;
      } else if (note) {
        note.parentNode.removeChild(note);
      }
    });
  }

  var syncing = false;
  function syncCart() {
    if (syncing) return;
    syncing = true;
    getCart().then(function (cart) {
      cartState = cart;
      syncing = false;
      decorate();
    }).catch(function () { syncing = false; });
  }

  /* Drawer +: stop increases above the cap before the drawer's own handler. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ccd-qty]') : null;
    if (!b || !cartState) return;
    var line = parseInt(b.getAttribute('data-line'), 10);
    var item = (cartState.items || [])[line - 1];
    var cap = lineCap(item);
    if (cap == null) return;
    var to = parseInt(b.getAttribute('data-ccd-qty'), 10);
    if (to > cap) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var notice = document.querySelector('.ccd-notice');
      var text = isPreLine(item)
        ? (C.limitText || '').replace('{n}', cap)
        : (C.stockText || '').replace('{n}', cap);
      if (notice) {
        notice.textContent = text;
        notice.hidden = false;
        clearTimeout(notice.__claudePoT);
        notice.__claudePoT = setTimeout(function () { notice.hidden = true; }, 4000);
      }
    }
  }, true);

  /* Re-apply whenever the DOM changes (quick-add modal opens, drawer
     re-renders). Batched per frame; only writes our own elements/attributes. */
  var queued = false;
  var lastLines = '';
  function onMutate() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      applyAll();
      var lines = document.querySelectorAll('.ccd-item[data-line]').length + ':' +
        Array.prototype.map.call(document.querySelectorAll('.ccd-qty-value'), function (n) { return n.textContent; }).join(',');
      if (lines !== lastLines) { lastLines = lines; syncCart(); } else decorate();
    });
  }

  function init() {
    hookPubSub();
    applyAll();
    syncCart();
    if (window.MutationObserver) {
      new MutationObserver(onMutate).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
